import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTransition, animated } from 'react-spring'
import styled from 'styled-components'
import { AppBar, Toolbar, IconButton, Typography } from '@material-ui/core'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import { displayLegs } from './utilities'

// Add configuration for the animation

const AnimatedBottomBar = styled(animated(AppBar))`
  &.MuiAppBar-positionFixed {
    top: auto;
    bottom: 56px;
    z-index: 1;
  }
`

const Counter = styled.div`
  height: 24px;
  width: 24px;
  background-color: ${props => props.theme.palette.background.paper};
  color: ${props => props.theme.palette.primary.main};
  line-height: 24px;
  border-radius: 100%;
  text-align: center;
  font-weight: 600;
`

const Title = styled(Typography)`
  margin-left: ${props => props.theme.spacing(2)}px;
`

const Symbol = styled(Typography)`
  margin-left: ${props => props.theme.spacing(2)}px;
`

const Odds = styled(Typography)`
  margin-left: ${props => props.theme.spacing(2)}px;
`

const SnackBar = snackBarProps => {
  const {
    isOpen,
    count,
    validMultiLegs,
    bet,
    totalOdds,
    setHold,
    setFullSlip,
    setScrollAllowance, // Need to call this in order to adjust body scroll height
  } = snackBarProps
  // counter to determine direction
  const prevCountRef = useRef()
  useEffect(() => {
    prevCountRef.current = count
  })
  const prevCount = prevCountRef.current

  // // determine if snackBar should be held
  // // if counter is going up or down
  const checkHoldSnackbar = (current, prev) => {
    if (prev > current && count === 1) {
      setHold(true)
    } else if (count === 0) {
      setHold(false)
    }
  }

  // on update of component check
  // if we need to hold
  const mounted = useRef()
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
      // this will capture the route change
      setHold(true)
    } else {
      // do componentDidUpate logic
      checkHoldSnackbar(count, prevCount)
    }
  })

  const renderTitle = () => {
    if (count === 1) {
      return bet.name
    }
    if (validMultiLegs.length === count) {
      return displayLegs(count)
    }
    return 'Bet Slip'
  }

  // Capture a reference of the snackbar to obtain its height
  // We'll send this value to the setScrollAllowance function
  const snackBarRef = useRef(null)

  const SnackBarAnimation = useTransition(isOpen, null, {
    config: { tension: 250 },
    from: { transform: `translate3d(0,100%,0)` },
    enter: { transform: `translate3d(0,0,0)` },
    leave: { transform: `translate3d(0,100%,0)` },
    onRest: () => {
      if (isOpen) {
        setScrollAllowance(snackBarRef.current.clientHeight, true)
      }
    },
    onDestroyed: () => setScrollAllowance(0, true),
  })

  return SnackBarAnimation.map(
    ({ item, key, props }) =>
      item && (
        <AnimatedBottomBar
          key={key}
          style={props}
          position="fixed"
          color="primary"
          onClick={() => setFullSlip(true)}
          ref={snackBarRef}
        >
          <Toolbar>
            {count > 1 && <Counter>{count}</Counter>}
            <Title variant="body1" color="inherit" noWrap>
              {renderTitle()}
            </Title>{' '}
            {validMultiLegs.length === count && (
              <>
                <Symbol variant="body1" color="inherit">
                  @
                </Symbol>
                <Odds variant="subtitle1" color="inherit">
                  {totalOdds.toFixed(2)}
                </Odds>
              </>
            )}
            <IconButton
              edge="end"
              color="inherit"
              aria-label="maximise"
              style={{ marginLeft: `auto` }}
            >
              <KeyboardArrowUpIcon />
            </IconButton>
          </Toolbar>
        </AnimatedBottomBar>
      )
  )
}

SnackBar.propTypes = {
  totalOdds: PropTypes.number,
  count: PropTypes.number,
  validMultiLegs: PropTypes.array,
  isOpen: PropTypes.bool,
  setHold: PropTypes.func,
}

export default SnackBar
